/**
 * String utility functions for the application
 */
export const useStringUtils = () => {
    /**
     * Normalize whitespace in strings
     */
    const normalizeString = (str: string): string => {
        return str.replace(/\s+/g, ' ').trim();
    };

    return {
        normalizeString,
    };
};
